{
  "guidance": {
    "tours": {
      "T02": {
        "title": "Find items and prepare a request",
        "summary": "Search the catalogue, read an item's terms, and get your cart ready for review.",
        "openCart": "Open Cart from the menu, then choose Continue in Help & tours.",
        "search": {
          "title": "Search the catalogue",
          "body": "Search in Arabic or English, and narrow the list with the filters your role can use. Only items approved for your purchasing unit are listed."
        },
        "itemFacts": {
          "title": "Read the item's terms",
          "body": "Each item shows its price, pack, tax, minimum order and lead time, as set by the agreement. When an item cannot be ordered here, its card says why."
        },
        "add": {
          "title": "Add to cart",
          "body": "Enter a quantity, then add the item to your cart. One cart can hold items from several suppliers, in one currency. This guide adds nothing for you."
        },
        "offCatalogue": {
          "title": "Not in the catalogue?",
          "body": "Describe what you need and procurement sources it. You do not choose the supplier or the price."
        },
        "cartLines": {
          "title": "Your cart",
          "body": "Each line shows its price and quantity. The price and source are set by HQ and cannot be changed here. A quantity you change is saved when you leave the field."
        },
        "cartDetails": {
          "title": "Required date and business reason",
          "body": "Say when you need the items and why. Each is saved when you leave the field."
        },
        "review": {
          "title": "Review & submit",
          "body": "Review & submit shows the quantities, the required date, the budget message and the expected approval route. Submitting from there creates a real purchase request. You submit it yourself."
        }
      },
      "T03": {
        "title": "Track, correct and reorder",
        "summary": "Find your requests, see who has each one, amend a returned request and reorder a past one.",
        "openRequest": "Open one of your requests from the list, then choose Continue in Help & tours.",
        "filters": {
          "title": "Find a request",
          "body": "Narrow the list by status, purchasing unit or date. The filters stay in the page address, so Back returns you to the same list."
        },
        "list": {
          "title": "Where each request is",
          "body": "Each row shows the status and what happens next. Open a request to see its full record, including who has it now."
        },
        "nextAction": {
          "title": "What happens next",
          "body": "This line says what happens next and who has the request. When an approver returns it, their instruction is shown here."
        },
        "tabs": {
          "title": "The request record",
          "body": "Items, the approval workflow, the budget impact and the history each have a tab. The approval workflow shows every decision with its reason."
        },
        "amend": {
          "title": "Amend a returned request",
          "body": "When a request is returned for amendment, Amend opens it with the approver's instruction. After your changes it is checked again, and you resubmit it for approval."
        },
        "reorder": {
          "title": "Reorder",
          "body": "Reorder copies this request's items into your cart, at today's prices and terms. Anything that can no longer be ordered is listed there. You reorder yourself."
        },
        "reorderAbsent": "Reorder is offered once a request has been submitted. This request is still a draft, so it has nothing to reorder yet."
      },
      "T04": {
        "title": "Review an approval",
        "summary": "Your approvals list, what to check on a request, and the four decisions.",
        "openApproval": "Open a request from your approvals list, then choose Continue in Help & tours.",
        "inbox": {
          "title": "Waiting for your decision",
          "body": "Only requests at your level now, or delegated to you, are listed; a delegated one says from whom and until when. Each shows the amount, the level, the budget position, when it is due and any exceptions. Open one to decide."
        },
        "why": {
          "title": "Why it needs you",
          "body": "The rule that routed this request to you, and any exception to check before you decide."
        },
        "lines": {
          "title": "Lines and quantities",
          "body": "What is being bought, line by line. A partial approval can only reduce a quantity, never raise it."
        },
        "budget": {
          "title": "Budget impact",
          "body": "The budget this request draws on and what would remain. Budget control is advisory: going over changes the approval route, it does not block the request."
        },
        "workflow": {
          "title": "Approval workflow",
          "body": "Every level, who has decided so far, and who decides after you."
        },
        "decide": {
          "title": "Your decision",
          "body": "Approve, partially approve, return for amendment or reject. A partial approval, a return and a rejection each need a reason. When you decide on someone's behalf, the decision is recorded with both names. Choosing a decision opens its confirmation, which you complete yourself."
        }
      },
      "T05": {
        "title": "Source a non-catalogue need",
        "summary": "From a need in the sourcing queue to an enquiry, the suppliers' quotes and your award decision.",
        "openForm": "Choose Start enquiry on a need in the sourcing queue, then choose Continue in Help & tours.",
        "openEnquiry": "Open an enquiry from the sourcing queue, then choose Continue in Help & tours.",
        "queue": {
          "title": "The sourcing queue",
          "body": "Needs sent to sourcing, and the enquiries raised for them, in one list. Start enquiry opens the enquiry form; nothing is created until you confirm there."
        },
        "lines": {
          "title": "What you are asking for",
          "body": "The enquiry asks for the need's lines and quantities. You name no supplier and no price here: the suppliers quote them."
        },
        "draft": {
          "title": "A draft first",
          "body": "Creating the enquiry saves it as a draft. Nothing reaches a supplier until you open it."
        },
        "suppliers": {
          "title": "Invited suppliers",
          "body": "In a draft, choose which qualified suppliers to invite. Once the enquiry is open, every invited supplier is listed with its reply. Each supplier sees only its own invitation."
        },
        "open": {
          "title": "Opening the enquiry",
          "body": "Opening invites the chosen suppliers, who can reply until the deadline. After that, the enquiry shows its number, the deadline and how many suppliers have replied. You open it yourself when it is ready."
        },
        "comparison": {
          "title": "Compare the responses",
          "body": "Each supplier's quote, with the same facts side by side. Fidelen does not score or rank them: the choice is yours."
        },
        "decision": {
          "title": "Record your decision",
          "body": "Award to the chosen supplier, or close with no award; either needs a reason. An award turns the winning offer into approved buying data. It does not place an order or commit any budget. You record it yourself."
        }
      },
      "T06": {
        "title": "Track and maintain an order",
        "summary": "An order's version, its four separate statuses, the supplier's answers and receipts, and what amending or cancelling does.",
        "openOrder": "Open an order from the list, then choose Continue in Help & tours.",
        "list": {
          "title": "Purchase orders",
          "body": "Each order shows its supplier, its purchasing unit and when it is needed, and where it stands in four columns: the order, the supplier, delivery and invoicing. Open an order to see its record."
        },
        "header": {
          "title": "The order",
          "body": "The order number and its current version, the request it came from and the supplier it goes to."
        },
        "status": {
          "title": "Four separate statuses",
          "body": "The order, the supplier's answer, delivery and invoicing are shown apart and never merged, so one can move on without hiding the others."
        },
        "responses": {
          "title": "Supplier responses",
          "body": "What the supplier told you, and when: confirmations, delivery dates, shortfalls, questions and dispatches."
        },
        "receipts": {
          "title": "Receipts",
          "body": "What was received against each line, each receipt tied to the version it was received on. Receipts are evidence of delivery."
        },
        "versions": {
          "title": "Version history",
          "body": "Each issued version is a fixed document, and a new version never rewrites an old one. Opening a document is recorded in the audit trail, so this guide does not open one."
        },
        "actions": {
          "title": "Changing the order",
          "body": "Amending creates a new version and keeps the old one; cancelling releases only what is still outstanding. Each asks for a reason and shows its consequences before anything happens. You make these changes yourself."
        },
        "actionsAbsent": "None of the changes your role allows applies to this order as it stands: a completed or cancelled order, for example, cannot be changed. When a change applies, it is shown with the order."
      },
      "T07": {
        "title": "Receive a delivery",
        "summary": "Deliveries waiting for you, what is still outstanding, reporting a problem, and closing short.",
        "openOrder": "Open an order from the receiving list, then choose Continue in Help & tours.",
        "queue": {
          "title": "Deliveries to receive",
          "body": "Orders expected at your purchasing units and waiting for a receipt. Open one to record what arrived."
        },
        "facts": {
          "title": "The order you are receiving",
          "body": "The version you are receiving against, where it is delivered and when it is expected, and the supplier's dispatch if one was reported."
        },
        "lines": {
          "title": "Ordered, accepted, outstanding",
          "body": "Each line shows what was ordered, what was already accepted and what is still outstanding. Enter what arrived today. If something was wrong with a line, use Report a problem on it."
        },
        "delivery": {
          "title": "Delivery details",
          "body": "The supplier's delivery note and your notes on this delivery. If an expected delivery has not arrived, report that it is late here."
        },
        "history": {
          "title": "Receiving history",
          "body": "Every receipt already recorded on this order. A receipt cannot be edited afterwards: a correction is a further receipt."
        },
        "closeShort": {
          "title": "Close short",
          "body": "When the rest will never arrive under this order, close it short with a reason. That releases the budget still held for it and cannot be undone. It is a separate decision from receiving."
        },
        "record": {
          "title": "Record the receipt",
          "body": "Everything arrived correctly records every outstanding line in full, at once. Record what I entered records only what you entered. You record the receipt yourself."
        }
      },
      "T08": {
        "title": "Invoice evidence and reports",
        "summary": "Record a supplier's invoice as evidence, see what completes an order, and find and filter your reports.",
        "openOrder": "Open a purchase order, then choose Continue in Help & tours.",
        "openReport": "Open a report from the list, then choose Continue in Help & tours.",
        "invoices": {
          "title": "Supplier invoices",
          "body": "Invoices recorded against this order. Fidelen keeps them as evidence: it does not issue, approve or pay them."
        },
        "recordInvoice": {
          "title": "Record an invoice",
          "body": "Opens a short form for the supplier's invoice number, date, amounts and PDF file. This guide does not open the form or upload anything."
        },
        "completion": {
          "title": "When an order is complete",
          "body": "The procurement record is complete when every quantity is received or closed short, and at least one invoice is recorded."
        },
        "audit": {
          "title": "Audit trail",
          "body": "Who did what, and when, in your organisation. Use the filters to narrow it down."
        },
        "reports": {
          "title": "Your reports",
          "body": "The reports your role can read, worked out live from the records in your scope. Open one to see its figures."
        },
        "filters": {
          "title": "Filter a report",
          "body": "Choose the period, the locations and the grouping. The figures change straight away."
        },
        "export": {
          "title": "Export",
          "body": "Exports what you see, with the same filters and scope. Every export is recorded in the audit trail. You export yourself."
        }
      },
      "T09": {
        "title": "Administration and readiness",
        "summary": "Go-live readiness, imports, users, roles, approval rules and budgets.",
        "readiness": {
          "title": "Go-live readiness",
          "body": "Checked live against your current setup, so it shows what is really configured and what is still outstanding."
        },
        "import": {
          "title": "Import master data",
          "body": "Upload a CSV or Excel file. It is checked first, and nothing is created until you apply it. This guide never chooses a file."
        },
        "importHistory": {
          "title": "Import history",
          "body": "Every file checked or imported, with its result. Open one to see its rows."
        },
        "users": {
          "title": "Users",
          "body": "People, their roles and their scope: what each person can see and do."
        },
        "roles": {
          "title": "Roles",
          "body": "Named sets of permissions. A role gives exactly the permissions it lists."
        },
        "rules": {
          "title": "Approval rules",
          "body": "Checked in priority order, lowest number first, with at most two human approval levels. The simulator shows which rule a request would meet."
        },
        "budgets": {
          "title": "Budgets",
          "body": "Spend control by purchasing unit, category and period. Control is advisory: going over does not block a request, it changes how it is approved."
        }
      },
      "T11": {
        "title": "Reply to an enquiry",
        "summary": "Your invitations, what the buyer asks for, your offer and how long it holds, documents, and sending or revising your quote.",
        "openEnquiry": "Open an enquiry from the list, then choose Continue in Help & tours.",
        "list": {
          "title": "Your enquiries",
          "body": "Only the enquiries this buyer has invited you to. You never see other suppliers or their prices. Open one to reply."
        },
        "header": {
          "title": "The enquiry",
          "body": "Its reference, your invitation status, whether it is open for responses, the reply-by date, the currency and the buyer."
        },
        "requirement": {
          "title": "What is being asked for",
          "body": "The lines and quantities, and the buyer's terms. Your price per unit is entered excluding tax."
        },
        "offer": {
          "title": "Your offer",
          "body": "The tax rate, how long you hold the price (separate from the reply deadline), minimum order, lead time and availability. Nothing is saved until you send. Once the enquiry closes, a notice replaces this form."
        },
        "documents": {
          "title": "Documents",
          "body": "PDF documents, up to 10 MB each, are attached to your offer after you send it."
        },
        "currentOffer": {
          "title": "Your current offer",
          "body": "After you send a quote, your current offer is shown on this page with its revision number, prices and terms. Start from my current offer copies it into the form; this guide does not press it."
        },
        "send": {
          "title": "Send your quote",
          "body": "Sending shares this offer with the buyer. It is an offer, not an order, and you can send a revised quote until the reply deadline. Sending is possible once every line has a price. You send it yourself."
        }
      }
    }
  }
}
